import appConfig from 'app-config';
import { withTranslations } from 'src/i18n/static-generation';
import { PageMetas } from 'src/types/meta';
import VipRatingView from 'src/views/VipRating';
export const getStaticProps = withTranslations<PageMetas>(() => {
  if (!appConfig.features.vip.enabled) {
    return {
      notFound: true
    };
  }
  return {
    props: {
      noindex: true,
      isIncidental: true
    }
  };
});
export default function Page() {
  if (!appConfig.features.vip.enabled) {
    return null;
  }
  return <VipRatingView data-sentry-element="VipRatingView" data-sentry-component="Page" data-sentry-source-file="vip_rating.tsx" />;
}